import Notification from "@/types/Notification.interface"

interface State {
    notificationsUnreadCount: number
    notificationsUnread: Notification[]
}

const defaults = () => {
    return {
        notificationsUnreadCount: 0,
        notificationsUnread: []
    }
}

export default {
    state: defaults(),
    mutations: {
        notificationsUnreadCountSet(state: State, count: number): void {
            state.notificationsUnreadCount = count
        },
        notificationsUnreadRemove(state: State, ids: string[]): void {
            //  Get our global notifications list
            const unread = state.notificationsUnread

            //  Else, filter out our removed ids
            const filtered = unread.filter((x: Notification) => !ids.includes(x.id))

            //  Replace our list with the filtered list
            state.notificationsUnread = filtered
        },
        notificationsUnreadSet(state: State, notifications: Notification[]): void {
            state.notificationsUnread = notifications
        },
        notificationsUnreadSync(state: State, notifications: Notification[]): void {
            //  Get the current unread notifications list
            const currentUnread = state.notificationsUnread

            //  Get the ids of notifications that have been read
            const readIds = notifications.filter(x => x.read_at != null).map(x => x.id)

            //  We need to remove read notifications
            let filtered = currentUnread.filter(x => !readIds.includes(x.id))

            //  Get the notifications that are unread
            const newUnread = notifications.filter(x => x.read_at == null)

            //  We need to add unread notifications
            filtered = window.removeDuplicatesById(filtered, newUnread)

            //  Update the unread notifications list
            state.notificationsUnread = filtered

            //  Sort our notifications by their created_at
            state.notificationsUnread.sort((a: Notification, b: Notification) => {
                //  @ts-ignore
                return +window.getDate(b.created_at) - +window.getDate(a.created_at)
            })
        },
        notificationsUnreadReset(state: State): void {
            Object.assign(state, defaults())
        }
    },
    actions: {
        notificationsUnreadGet({ commit, getters }): Promise<Notification[]> {
            //  Assemble the API endpoint
            const url = `${getters.api}/notifications/unread`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Update our unread list
                commit('notificationsUnreadSet', response.data)

                //  Return the unread list
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        notificationsUnreadCount(state: State): number {
            return state.notificationsUnreadCount
        },
        notificationsUnread(state: State): Notification[] {
            return state.notificationsUnread
        }
    }
}
